module.exports = __webpack_public_path__ + "static/media/droopy_lower.8040009d.svg";